import Vue from "vue"

const eventBus = new Vue()
Vue.prototype.$bus = eventBus
export default (context, inject) => {
  inject("bus", eventBus)
}
